/**
 * @generated SignedSource<<d1dfc44cf8efb0acaa00c6d0f4a8a2f2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type OpinionScaleChoice = "Agree" | "Disagree" | "Neutral" | "StronglyAgree" | "StronglyDisagree";
export type RespondedFrom = "email" | "mobile" | "slack" | "web";
export type SavePulseResponseInput = {
  clientMutationId?: string | null;
  comment?: string | null;
  eNPSChoice?: number | null;
  opinion?: OpinionScaleChoice | null;
  pulseId: string;
  questionRevisionId: string;
  respondedFrom: RespondedFrom;
};
export type savePulseResponseMutation$variables = {
  input: SavePulseResponseInput;
};
export type savePulseResponseMutationVariables = savePulseResponseMutation$variables;
export type savePulseResponseMutation$data = {
  readonly savePulseResponse: {
    readonly user: {
      readonly submittedPulsesCount: number;
      readonly tasksList: ReadonlyArray<{
        readonly __typename: "RespondToPulseTask";
        readonly id: string;
        readonly pulseGroup: {
          readonly entityId: string;
        } | null;
      } | {
        // This will never be '%other', but we need some
        // value in case none of the concrete values match.
        readonly __typename: "%other";
      } | null>;
    } | null;
    readonly pulse: {
      readonly id: string;
      readonly skippedAt: DateString | null;
      readonly respondedFrom: RespondedFrom | null;
      readonly question: {
        readonly id: string;
        readonly body: string;
      };
      readonly pulseGroup: {
        readonly id: string;
        readonly remainingPulsesCount: number;
      };
    } | null;
    readonly pulseGroup: {
      readonly remainingPulses: ReadonlyArray<{
        readonly id: string;
        readonly question: {
          readonly currentRevision: {
            readonly id: string;
          } | null;
          readonly body: string;
          readonly hasComment: boolean;
        };
      }>;
      readonly totalPulsesCount: number;
      readonly remainingPulsesCount: number;
      readonly skippedPulsesCount: number;
    } | null;
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type savePulseResponseMutationResponse = savePulseResponseMutation$data;
export type savePulseResponseMutation = {
  variables: savePulseResponseMutationVariables;
  response: savePulseResponseMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "submittedPulsesCount",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skippedAt",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "respondedFrom",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "body",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "remainingPulsesCount",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PulseGroup",
  "kind": "LinkedField",
  "name": "pulseGroup",
  "plural": false,
  "selections": [
    (v4/*: any*/),
    (v9/*: any*/)
  ],
  "storageKey": null
},
v11 = [
  (v4/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasComment",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalPulsesCount",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "skippedPulsesCount",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "errors",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "savePulseResponseMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SavePulseResponsePayload",
        "kind": "LinkedField",
        "name": "savePulseResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasksList",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PulseGroup",
                        "kind": "LinkedField",
                        "name": "pulseGroup",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "RespondToPulseTask",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Pulse",
            "kind": "LinkedField",
            "name": "pulse",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  (v4/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PulseGroup",
            "kind": "LinkedField",
            "name": "pulseGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Pulse",
                "kind": "LinkedField",
                "name": "remainingPulses",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "question",
                    "plural": false,
                    "selections": [
                      {
                        "alias": "currentRevision",
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "currentRevisionV2",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      (v12/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v9/*: any*/),
              (v14/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "savePulseResponseMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "SavePulseResponsePayload",
        "kind": "LinkedField",
        "name": "savePulseResponse",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "tasksList",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "InlineFragment",
                    "selections": [
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "PulseGroup",
                        "kind": "LinkedField",
                        "name": "pulseGroup",
                        "plural": false,
                        "selections": [
                          (v5/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "type": "RespondToPulseTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ApprovePeerNominationsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "CalibrateTalentReviewTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ConfirmReceivingPacketTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "CreateGoalForGoalCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "DocumentsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "EnableOneOnOneTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "EndRevieweeCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "FinalizeReviewPacketTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "GiveFeedbackTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "PTORequestTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "PerformPostScoringReviewTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "PerformReviewsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "PerformTalentReviewTaskType",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "PublishGrowthAreaReminderTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "RespondToBackboneEmployeeRegistrationFormTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "RespondToSurveyAssignmentTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "RespondToSurveyTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ReviewCompensationCycleTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ReviewReportCheckinTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ScoreRevieweeTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "SelectPeersTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "SetupOneOnOnesWithNewReportTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "SetupUpdatesWithNewReportTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ShareCompensationCycleResultsToTeamTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "StartSurveyManagerActionPlanningTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "UpdateGoalTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "UpdateGoalsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "UpdateTotalRewardsCompanyCurrencyTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ViewCalibrationGroupsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ViewCompensationCycleResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ViewCompensationCycleTeamResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ViewCompensationTotalRewardsStatementTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ViewSharedCompensationCycleResultsTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ViewSurveyActionPlanTask",
                    "abstractKey": null
                  },
                  {
                    "kind": "InlineFragment",
                    "selections": (v11/*: any*/),
                    "type": "ViewSurveyCommentTask",
                    "abstractKey": null
                  }
                ],
                "storageKey": null
              },
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Pulse",
            "kind": "LinkedField",
            "name": "pulse",
            "plural": false,
            "selections": [
              (v4/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "question",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v8/*: any*/)
                ],
                "storageKey": null
              },
              (v10/*: any*/)
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PulseGroup",
            "kind": "LinkedField",
            "name": "pulseGroup",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Pulse",
                "kind": "LinkedField",
                "name": "remainingPulses",
                "plural": true,
                "selections": [
                  (v4/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "question",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": "currentRevision",
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "currentRevisionV2",
                        "plural": false,
                        "selections": [
                          (v3/*: any*/),
                          (v4/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v8/*: any*/),
                      (v12/*: any*/),
                      (v4/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v13/*: any*/),
              (v9/*: any*/),
              (v14/*: any*/),
              (v4/*: any*/)
            ],
            "storageKey": null
          },
          (v15/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "e7bd576e45c9f5684a073bdefd6510f2",
    "id": null,
    "metadata": {},
    "name": "savePulseResponseMutation",
    "operationKind": "mutation",
    "text": "mutation savePulseResponseMutation(\n  $input: SavePulseResponseInput!\n) {\n  savePulseResponse(input: $input) {\n    user {\n      submittedPulsesCount\n      tasksList {\n        __typename\n        ... on RespondToPulseTask {\n          id\n          pulseGroup {\n            entityId\n            id\n          }\n        }\n        ... on ApprovePeerNominationsTask {\n          id\n        }\n        ... on CalibrateTalentReviewTask {\n          id\n        }\n        ... on ConfirmReceivingPacketTask {\n          id\n        }\n        ... on CreateGoalForGoalCycleTask {\n          id\n        }\n        ... on DocumentsTask {\n          id\n        }\n        ... on EnableOneOnOneTask {\n          id\n        }\n        ... on EndRevieweeCycleTask {\n          id\n        }\n        ... on FinalizeReviewPacketTask {\n          id\n        }\n        ... on GiveFeedbackTask {\n          id\n        }\n        ... on PTORequestTask {\n          id\n        }\n        ... on PerformPostScoringReviewTask {\n          id\n        }\n        ... on PerformReviewsTask {\n          id\n        }\n        ... on PerformTalentReviewTaskType {\n          id\n        }\n        ... on PublishGrowthAreaReminderTask {\n          id\n        }\n        ... on RespondToBackboneEmployeeRegistrationFormTask {\n          id\n        }\n        ... on RespondToSurveyAssignmentTask {\n          id\n        }\n        ... on RespondToSurveyTask {\n          id\n        }\n        ... on ReviewCompensationCycleTask {\n          id\n        }\n        ... on ReviewReportCheckinTask {\n          id\n        }\n        ... on ScoreRevieweeTask {\n          id\n        }\n        ... on SelectPeersTask {\n          id\n        }\n        ... on SetupOneOnOnesWithNewReportTask {\n          id\n        }\n        ... on SetupUpdatesWithNewReportTask {\n          id\n        }\n        ... on ShareCompensationCycleResultsToTeamTask {\n          id\n        }\n        ... on StartSurveyManagerActionPlanningTask {\n          id\n        }\n        ... on UpdateGoalTask {\n          id\n        }\n        ... on UpdateGoalsTask {\n          id\n        }\n        ... on UpdateTotalRewardsCompanyCurrencyTask {\n          id\n        }\n        ... on ViewCalibrationGroupsTask {\n          id\n        }\n        ... on ViewCompensationCycleResultsTask {\n          id\n        }\n        ... on ViewCompensationCycleTeamResultsTask {\n          id\n        }\n        ... on ViewCompensationTotalRewardsStatementTask {\n          id\n        }\n        ... on ViewSharedCompensationCycleResultsTask {\n          id\n        }\n        ... on ViewSurveyActionPlanTask {\n          id\n        }\n        ... on ViewSurveyCommentTask {\n          id\n        }\n      }\n      id\n    }\n    pulse {\n      id\n      skippedAt\n      respondedFrom\n      question {\n        __typename\n        id\n        body\n      }\n      pulseGroup {\n        id\n        remainingPulsesCount\n      }\n    }\n    pulseGroup {\n      remainingPulses {\n        id\n        question {\n          __typename\n          currentRevision: currentRevisionV2 {\n            __typename\n            id\n          }\n          body\n          hasComment\n          id\n        }\n      }\n      totalPulsesCount\n      remainingPulsesCount\n      skippedPulsesCount\n      id\n    }\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "d4213e72a47a1867784b753abaeb19c9";

export default node;
